<template>
  <div>
    <goods-item v-if="enabled" :model="model" :good="good" :store-lang="$store.state.locale.locale" @refresh="init" />
  </div>
</template>

<script>
import { Message } from 'element-ui';
import { cloneDeep } from 'lodash-es'
import GoodsItem from './item.vue'

export default {
    name: 'StandaloneProductWidget',
    components: {
        GoodsItem
    },
    props: {
        model: {
            type: Object,
            default: () => {}
        },
        editing: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            good: {},
            enabled: false,
            loading: true
        }
    },
    created() {
        this.init()
    },
    methods: {
        init() {
            this.getDetail()
        },
        async getDetail() {
            try {
                if (this.editing) {
                    this.enabled = true
                    this.good = this.model.__mockData
                    this.loading = false
                    return
                }
                const params = {
                    merchant_id: this.$store.state.project.merchantId,
                    project_id: this.$store.state.project.projectId,
                    code: this.$route.query.goods_code,
                    enabled: 1
                }
                this.loading = true
                const [err, res] = await this.$utils.to(this.$api.good.getVirtualItems(params, { editing: this.editing }))
                if (!err) {
                    if (res.discount_info?.discount_level) {
                        this.$store.commit('goods/SET_DISCOUNT_INFO', cloneDeep(res.discount_info))
                    }
                    this.good = res?.data?.[0] || {}
                    this.enabled = res?.data?.length === 1
                    this.loading = false
                } else {
                    Message.error(err)
                    this.loading = false
                }
            } finally {
                this.$widgetReady()
            }
        }
    }
}
</script>

<style></style>